import { render, staticRenderFns } from "./AssetsMaterials.vue?vue&type=template&id=7ec797ab&"
import script from "./AssetsMaterials.vue?vue&type=script&lang=js&"
export * from "./AssetsMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports